import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import folderIdFactory from 'owa-service/lib/factory/folderId';
import itemId from 'owa-service/lib/factory/itemId';
import targetFolderIdFactory from 'owa-service/lib/factory/targetFolderId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
/**
 * Issue the service request to update categories of specified conversations
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @return a promise which contains ApplyConversationActionResponseMessage
 */
export default function updateConversationsCategoriesService(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var requestBody = configureRequestBody(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories);
    return applyConversationActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
/**
 * Configure the ApplyConversationActionRequest
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to add to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @return an ApplyConversationActionRequest
 */
function configureRequestBody(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var conversationActions = conversationActionContexts.map(function (conversationContext) {
        return createCategorizeConversationAction(conversationContext, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories);
    });
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * Configure the ApplyConversationActionRequest
 * @param conversationContext the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed to the conversations
 * @param clearCategories the categories to be removed to the conversations
 * @return the generated ConversationAction
 */
function createCategorizeConversationAction(conversationContext, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var categorizeAction = conversationAction({
        Action: 'UpdateAlwaysCategorizeRule',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        Categories: categoriesToAdd,
        CategoriesToRemove: categoriesToRemove,
        ClearCategories: clearCategories,
    });
    // folderId can be null in search mode.
    if (contextFolderId) {
        var targetFolderId = targetFolderIdFactory({
            BaseFolderId: folderIdFactory({
                Id: contextFolderId,
            }),
        });
        categorizeAction.ContextFolderId = targetFolderId;
    }
    return categorizeAction;
}
//# sourceMappingURL=updateConversationsCategoriesService.js.map